import { render, staticRenderFns } from "./PedidoCompraList.vue?vue&type=template&id=e96e251c&scoped=true&"
import script from "./PedidoCompraList.vue?vue&type=script&lang=js&"
export * from "./PedidoCompraList.vue?vue&type=script&lang=js&"
import style0 from "./PedidoCompraList.vue?vue&type=style&index=0&id=e96e251c&lang=scss&scoped=true&"
import style1 from "./PedidoCompraList.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./PedidoCompraList.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e96e251c",
  null
  
)

export default component.exports